/* THRIVE Cycling Science — article page behaviour.
 * Static-safe by design: every element this script touches already renders
 * correctly with zero JS (progress bar starts truthfully at 0%; TOC items
 * are plain links; nothing is hidden pending a JS-driven reveal). No
 * scroll-hijacking — this only ever adds a class or updates a width. */
(function () {
  'use strict';
  var root = document.querySelector('.csx-article');
  if (!root) return;

  // 1) Reading progress bar
  var fill = root.querySelector('.csx-topbar__progress-fill');
  if (fill) {
    var ticking = false;
    function updateProgress() {
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop;
      var docH = Math.max(0, doc.scrollHeight - window.innerHeight);
      var pct = docH > 0 ? Math.min(100, (scrollTop / docH) * 100) : 0;
      fill.style.width = pct + '%';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { updateProgress(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    updateProgress();
  }

  // 2) TOC active-section highlight (progressive enhancement only)
  var tocLinks = root.querySelectorAll('.csx-toc__item');
  var sections = root.querySelectorAll('.csx-body h2[id]');
  if (tocLinks.length && sections.length && 'IntersectionObserver' in window) {
    var byId = {};
    tocLinks.forEach(function (l) {
      var id = (l.getAttribute('href') || '').replace('#', '');
      byId[id] = l;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var link = byId[e.target.id];
        if (link && e.isIntersecting) {
          tocLinks.forEach(function (l) { l.classList.remove('is-active'); });
          link.classList.add('is-active');
        }
      });
    }, { rootMargin: '-30% 0% -60% 0%' });
    sections.forEach(function (s) { io.observe(s); });
  }
})();
